import styled from 'styled-components';

export const DivTableClienteUsuarios = styled.div.attrs({
  className: 'p-4 overflow-y-auto',
})`
  height: 20rem;
`;
